import React from "react";
import _ from "lodash";
import ApplicantsHit from "./Hit";

const ApplicantsHits = ({
                          hits,
                          isPostulation,
                          courseId,
                          workFlow,
                          reloadQuery,
                          showNotification,
                          isAdmin,
                          handleCheckApplicant,
                          isChecked,
                          updateHit,
                          reloadAfterUpdate,
                          selectionMap,
                          boardRef,
                          currentUserRole
                        }) => {
  return (
    <div>
      {_.map(hits, hit => (
        <ApplicantsHit
          key={hit._id}
          hit={hit}
          isPostulation={isPostulation}
          courseId={courseId}
          workFlow={workFlow}
          reloadQuery={reloadQuery}
          reloadAfterUpdate={reloadAfterUpdate}
          showNotification={showNotification}
          handleCheckApplicant={handleCheckApplicant}
          isChecked={isChecked(hit)}
          isAdmin={isAdmin}
          updateHit={updateHit}
          selectionMap={selectionMap}
          boardRef={boardRef}
          currentUserRole={currentUserRole}
        />
      ))}
    </div>
  );
};

export default ApplicantsHits;
